<template>
    <div class="form-group row">
        <label class="col-3 col-form-label" :class="{'text-md-right': !left}">{{ label }}</label>
        <div :class="{'col-9 col-md-6': !fullWidth, 'col-8': fullWidth}">
            <slot></slot>
        </div>
        <div class="col-md-3 offset-md-0 col-9 offset-3" v-if="!fullWidth">
            <slot name="help"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String
            },
            left: {
                type: Boolean,
                default: false
            },
            fullWidth: {
                type: Boolean,
                default: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/snippets/form-row.vue